import {Injectable} from '@angular/core';
import {ToastController} from "@ionic/angular";

export interface ToastDataInterface {
  header?: string;
  message?: string;
  duration?: number;
  position?: any;
  type?: 'default' | 'success' | 'warning' | 'error'
}

@Injectable({
  providedIn: 'root'
})
export class ToastService {
  private toast: HTMLIonToastElement;

  constructor(
    private toastCtrl: ToastController
  ) { }

  async open(data: ToastDataInterface = null) {
    const iconPrefix: Record<string, string> = {
      success: '✓ ',
      error: '✕ ',
      warning: '⚠ ',
    };
    const prefix = iconPrefix[data?.type] ?? '';

    const toast = await this.toastCtrl.create({
      header: data?.header ? prefix + data.header : undefined,
      message: data?.message,
      duration: data?.duration || (data?.type === 'error' ? 6000 : 4000),
      position: data?.position,
      cssClass: 'custom-toast ' + data?.type,
      htmlAttributes: { role: 'alert' },
      buttons: [
        {
          icon: 'close'
        }
      ]
    });
    await toast.present();
  }

  async closeAll() {
    let toast = (await this.toastCtrl.getTop());
    while (toast) {
      await toast.dismiss();
      toast = (await this.toastCtrl.getTop());
    }
  }

  async unavailable() {
    const toast = await this.toastCtrl.create({
      header: 'Fonction indisponible.',
      message: 'Cette fonction est en cours de développement.',
      duration: 3000,
      position: 'bottom',
      cssClass: 'custom-toast',
      buttons: [
        {
          icon: 'close'
        }
      ]
    });
    await toast.present();
  }
}
